import "./CompanyMarketCap.css";
import { escapeWealthHtml as esc, formatWealthValue as worth, type WealthResponse } from "./WealthTypes";

export function renderCompanyMarketCap(container: HTMLElement, data: WealthResponse): void {
  const company = data.company;
  if (!company) {
    container.innerHTML = "";
    return;
  }
  const change = company.daily_change_percent;
  const positive = Number(change || 0) >= 0;

  container.innerHTML = `
    <section class="company-marketcap-card">
      <div class="company-marketcap-heading">
        <div>
          <div class="wealth-kicker">MARKET CAPITALIZATION</div>
          <h1>${esc(company.name)}</h1>
          <div class="company-marketcap-symbol">${esc([company.exchange, company.ticker].filter(Boolean).join(": "))}</div>
        </div>
        ${company.is_placeholder ? `<span class="company-marketcap-seeded">Seeded</span>` : ""}
      </div>
      <div class="company-marketcap-value">${esc(company.display_market_cap || worth(company.market_cap_usd))}</div>
      <div class="company-marketcap-label">Market capitalization</div>
      ${company.share_price != null ? `
        <div class="company-marketcap-price-row">
          <strong>${esc(company.share_price.toLocaleString())} ${esc(company.currency || "USD")}</strong>
          ${change != null ? `<span class="${positive ? "positive" : "negative"}">${change > 0 ? "+" : ""}${esc(change.toFixed(2))}% today</span>` : ""}
        </div>
      ` : ""}
      <div class="company-marketcap-note">
        ${company.is_placeholder
          ? "Initial seeded value. The scheduled backend refresh is configured to replace it with cached source data."
          : "Cached by AyeSearch from the configured market-cap source."}
      </div>
      <div class="wealth-source">
        <span>AyeSearch market data cache</span>
        ${data.source?.url ? `<a href="${esc(data.source.url)}" target="_blank" rel="noopener noreferrer">${esc(data.source.name || "Source")}</a>` : ""}
      </div>
    </section>
  `;
}
